import api from '@/services/api';
import type { Product, ProductCapability, ProductPayload, ProductStatus } from '@/features/products/types/products.types';
import { transformApiProduct, type RawApiProduct } from '@/features/products/services/productTransform';

const smrPath = '/smr';

export const fetchProduct = async (id: string): Promise<Product> => {
    const response = await api.get<{ data: RawApiProduct }>(`${smrPath}/products/${id}`);
    return transformApiProduct(response.data.data);
};

export const createProduct = async (payload: ProductPayload): Promise<Product> => {
    const response = await api.post<{ data: RawApiProduct }>(`${smrPath}/products`, payload);
    return transformApiProduct(response.data.data);
};

export const updateProduct = async (id: string, payload: ProductPayload): Promise<Product> => {
    const response = await api.put<{ data: RawApiProduct }>(`${smrPath}/products/${id}`, payload);
    return transformApiProduct(response.data.data);
};

export const retireProduct = async (id: string): Promise<Product> => {
    const response = await api.patch<{ data: RawApiProduct }>(`${smrPath}/products/${id}/retire`);
    return transformApiProduct(response.data.data);
};

export const restoreProduct = async (id: string): Promise<Product> => {
    const response = await api.patch<{ data: RawApiProduct }>(`${smrPath}/products/${id}/restore`);
    return transformApiProduct(response.data.data);
};

export const fetchProductStatuses = async (): Promise<ProductStatus[]> => {
    const { data } = await api.get<{ data: ProductStatus[] }>(`${smrPath}/product-statuses`);
    return data.data;
};

export const fetchProductCapabilities = async (): Promise<ProductCapability[]> => {
    const { data } = await api.get<{ data: ProductCapability[] }>(`${smrPath}/product-capabilities`);
    return data.data;
};
